module.exports = __webpack_public_path__ + "media/components/assets/icons/checkbox_click-0b20a0ae659fe89a03c7c41edf4c37f3.svg";